// extracted by mini-css-extract-plugin
module.exports = {"srxjktg":"srxjktg","s1g1059s":"s1g1059s","s1m6pu8v":"s1m6pu8v","s15frz8i":"s15frz8i","s1sd6138":"s1sd6138","s1prja2s":"s1prja2s","video-embed":"video-embed"};